import { Component, h } from "preact";

import { Icon } from "../../Icon";

export function StarBigOutlineIcon(rest) {
  return (
    <Icon {...rest}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.6126 15.8986L24 0L17.3874 15.8986L0.223572 17.2746L13.3006 28.4764L9.30535 45.2254L24 36.25L38.6946 45.2254L34.6994 28.4764L47.7764 17.2746L30.6126 15.8986ZM45.2999 18.0792L29.9238 16.8465L24 2.60396L18.0762 16.8465L2.70008 18.0792L14.415 28.1143L10.8359 43.1188L24 35.0782L37.1641 43.1188L33.5849 28.1143L45.2999 18.0792Z"
      />
    </Icon>
  );
}
